import { useEffect, useState } from 'react';

export default function useHeaderHeight() {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const apiReady = () =>
      window.$mos_layouts.on &&
      window.$mos_layouts.on('change:headerHeight', height =>
        setHeaderHeight(height)
      );
    if (window.$mos_layouts && window.$mos_layouts.on) {
      apiReady();
    } else {
      document.addEventListener('change:displayHeader', apiReady, false);
    }
  }, []);

  return [headerHeight];
}
